"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.costCSData = {
    "08242020": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/31/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7069,
            fee1: 0,
            textbooks1: 102,
            supplies1: 620,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: "",
            tuition2: 7069,
            fee2: 0,
            textbooks2: 224,
            supplies2: 498,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: "",
            tuition3: 7069,
            fee3: 0,
            textbooks3: 0,
            supplies3: 157,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: "",
            tuition4: 7068,
            fee4: 0,
            textbooks4: 0,
            supplies4: 158,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: "",
            tuition5: 4524,
            fee5: 434,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: "",
            tuition6: 4524,
            fee6: 434,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/31/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7125,
            fee1: 0,
            textbooks1: 215,
            supplies1: 459,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: "",
            tuition2: 7125,
            fee2: 0,
            textbooks2: 292,
            supplies2: 381,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: "",
            tuition3: 7125,
            fee3: 0,
            textbooks3: 324,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: "",
            tuition4: 7125,
            fee4: 0,
            textbooks4: 323,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: "",
            tuition5: 4362,
            fee5: 366,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: "",
            tuition6: 4362,
            fee6: 366,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/12/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7236,
            fee1: 0,
            textbooks1: 250,
            supplies1: 462,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: "",
            tuition2: 7236,
            fee2: 0,
            textbooks2: 280,
            supplies2: 432,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: "",
            tuition3: 5208,
            fee3: 322,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/12/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6807,
            fee1: 0,
            textbooks1: 454,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: "",
            tuition2: 6807,
            fee2: 0,
            textbooks2: 454,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: "",
            tuition3: 4651.5,
            fee3: 786.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/12/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6742,
            fee1: 0,
            textbooks1: 374,
            supplies1: 224,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: "",
            tuition2: 6741,
            fee2: 0,
            textbooks2: 406,
            supplies2: 193,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: "",
            tuition3: 4335,
            fee3: 945,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: "",
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "10052020": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/12/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7069,
            fee1: 0,
            textbooks1: 260,
            supplies1: 620,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/31/2021"),
            tuition2: 7069,
            fee2: 0,
            textbooks2: 381,
            supplies2: 498,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/16/2021"),
            tuition3: 7069,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/05/2021"),
            tuition4: 7068,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/09/2022"),
            tuition5: 4524,
            fee5: 434,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/13/2022"),
            tuition6: 4524,
            fee6: 434,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("05/12/2022")
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/12/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6878,
            fee1: 0,
            textbooks1: 539,
            supplies1: 459,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/31/2021"),
            tuition2: 6877,
            fee2: 0,
            textbooks2: 615,
            supplies2: 381,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/16/2021"),
            tuition3: 6878,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/05/2021"),
            tuition4: 6877,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/09/2022"),
            tuition5: 4857,
            fee5: 366,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/13/2022"),
            tuition6: 4857,
            fee6: 366,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("05/12/2022")
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/23/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7236,
            fee1: 0,
            textbooks1: 250,
            supplies1: 462,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/21/2021"),
            tuition2: 7236,
            fee2: 0,
            textbooks2: 280,
            supplies2: 432,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/04/2021"),
            tuition3: 5208,
            fee3: 322,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/23/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/24/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6807,
            fee1: 0,
            textbooks1: 454,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/21/2021"),
            tuition2: 6807,
            fee2: 0,
            textbooks2: 454,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/04/2021"),
            tuition3: 4651.5,
            fee3: 786.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/24/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/24/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6742,
            fee1: 0,
            textbooks1: 374,
            supplies1: 417,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/21/2021"),
            tuition2: 6741,
            fee2: 0,
            textbooks2: 406,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/04/2021"),
            tuition3: 4335,
            fee3: 945,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/24/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "11162020": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("02/18/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7225,
            fee1: 0,
            textbooks1: 89,
            supplies1: 650,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/04/2021"),
            tuition2: 7225,
            fee2: 0,
            textbooks2: 210,
            supplies2: 457,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/15/2021"),
            tuition3: 5483,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/07/2021"),
            tuition4: 5483,
            fee4: 73,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/18/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("06/30/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6878,
            fee1: 0,
            textbooks1: 539,
            supplies1: 459,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/14/2021"),
            tuition2: 6877,
            fee2: 0,
            textbooks2: 615,
            supplies2: 381,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/04/2021"),
            tuition3: 6878,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/17/2021"),
            tuition4: 6877,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/20/2022"),
            tuition5: 4857,
            fee5: 366,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("04/24/2022"),
            tuition6: 4857,
            fee6: 366,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("06/30/2022")
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/04/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7236,
            fee1: 0,
            textbooks1: 250,
            supplies1: 462,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/04/2021"),
            tuition2: 7236,
            fee2: 0,
            textbooks2: 280,
            supplies2: 432,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/15/2021"),
            tuition3: 5208,
            fee3: 322,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/04/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/05/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6807,
            fee1: 0,
            textbooks1: 454,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/04/2021"),
            tuition2: 6807,
            fee2: 0,
            textbooks2: 454,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/15/2021"),
            tuition3: 4651.5,
            fee3: 786.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/05/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/05/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6742,
            fee1: 0,
            textbooks1: 374,
            supplies1: 417,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/04/2021"),
            tuition2: 6741,
            fee2: 0,
            textbooks2: 406,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/15/2021"),
            tuition3: 4335,
            fee3: 945,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/05/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "01112021": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("03/31/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7225,
            fee1: 0,
            textbooks1: 89,
            supplies1: 650,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/16/2021"),
            tuition2: 7225,
            fee2: 0,
            textbooks2: 211,
            supplies2: 458,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/26/2021"),
            tuition3: 5483,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("01/09/2022"),
            tuition4: 5483,
            fee4: 71,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("03/31/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("08/11/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6878,
            fee1: 0,
            textbooks1: 539,
            supplies1: 459,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/25/2021"),
            tuition2: 6877,
            fee2: 0,
            textbooks2: 615,
            supplies2: 381,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/15/2021"),
            tuition3: 6878,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/28/2021"),
            tuition4: 6877,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("04/03/2022"),
            tuition5: 4857,
            fee5: 366,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("06/05/2022"),
            tuition6: 4857,
            fee6: 366,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("08/11/2022")
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/16/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7236,
            fee1: 0,
            textbooks1: 250,
            supplies1: 462,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/16/2021"),
            tuition2: 7236,
            fee2: 0,
            textbooks2: 280,
            supplies2: 432,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/26/2021"),
            tuition3: 5208,
            fee3: 322,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("12/16/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/17/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6807,
            fee1: 0,
            textbooks1: 454,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/16/2021"),
            tuition2: 6807,
            fee2: 0,
            textbooks2: 454,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/26/2021"),
            tuition3: 4651.5,
            fee3: 786.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("12/17/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/17/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6742,
            fee1: 0,
            textbooks1: 374,
            supplies1: 417,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/16/2021"),
            tuition2: 6741,
            fee2: 0,
            textbooks2: 406,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/26/2021"),
            tuition3: 4335,
            fee3: 945,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("12/17/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("11/05/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 7075,
            fee1: 0,
            textbooks1: 422,
            supplies1: 363,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/16/2021"),
            tuition2: 7075,
            fee2: 0,
            textbooks2: 422,
            supplies2: 363,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/26/2021"),
            tuition3: 2698,
            fee3: 77,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/05/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "02222021": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/13/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7225,
            fee1: 0,
            textbooks1: 89,
            supplies1: 650,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2021"),
            tuition2: 7225,
            fee2: 0,
            textbooks2: 211,
            supplies2: 458,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/07/2021"),
            tuition3: 5483,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/20/2022"),
            tuition4: 5483,
            fee4: 71,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("05/13/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("09/22/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6878,
            fee1: 0,
            textbooks1: 539,
            supplies1: 459,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("06/06/2021"),
            tuition2: 6877,
            fee2: 0,
            textbooks2: 615,
            supplies2: 381,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/26/2021"),
            tuition3: 6878,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("01/30/2022"),
            tuition4: 6877,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("05/15/2022"),
            tuition5: 4857,
            fee5: 366,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("07/24/2022"),
            tuition6: 4857,
            fee6: 366,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("09/22/2022")
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/17/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7236,
            fee1: 0,
            textbooks1: 250,
            supplies1: 462,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2021"),
            tuition2: 7236,
            fee2: 0,
            textbooks2: 280,
            supplies2: 432,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/07/2021"),
            tuition3: 5208,
            fee3: 322,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/17/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/18/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6807,
            fee1: 0,
            textbooks1: 454,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/21"),
            tuition2: 6807,
            fee2: 0,
            textbooks2: 454,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/07/2021"),
            tuition3: 4651.5,
            fee3: 786.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/18/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/18/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6742,
            fee1: 0,
            textbooks1: 374,
            supplies1: 417,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2021"),
            tuition2: 6741,
            fee2: 0,
            textbooks2: 406,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/07/2021"),
            tuition3: 4335,
            fee3: 945,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/18/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("12/17/2021"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 7075,
            fee1: 0,
            textbooks1: 422,
            supplies1: 363,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2021"),
            tuition2: 7075,
            fee2: 0,
            textbooks2: 422,
            supplies2: 363,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/07/2021"),
            tuition3: 2698,
            fee3: 77,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("12/17/2021"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "04052021": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/24/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7095,
            fee1: 0,
            textbooks1: 300,
            supplies1: 1491,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/15/2021"),
            tuition2: 7095,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/09/2022"),
            tuition3: 5397,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/03/2022"),
            tuition4: 5397,
            fee4: 120,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("06/24/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("11/04/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6974,
            fee1: 0,
            textbooks1: 464,
            supplies1: 922,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/25/2021"),
            tuition2: 6974,
            fee2: 0,
            textbooks2: 463,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/07/2021"),
            tuition3: 7163,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/13/2022"),
            tuition4: 7163,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("07/03/2022"),
            tuition5: 4525,
            fee5: 0,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("09/04/2022"),
            tuition6: 4524,
            fee6: 778,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("11/04/2022")
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("04/01/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 7380,
            fee1: 0,
            textbooks1: 265,
            supplies1: 568,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/15/2021"),
            tuition2: 7380,
            fee2: 0,
            textbooks2: 265,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/09/2022"),
            tuition3: 4920,
            fee3: 648,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/01/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("04/01/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6803,
            fee1: 0,
            textbooks1: 611,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/15/2021"),
            tuition2: 6803,
            fee2: 0,
            textbooks2: 610,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/09/2022"),
            tuition3: 4536.5,
            fee3: 596.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/01/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("04/01/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2020",
            tuition1: 6414,
            fee1: 0,
            textbooks1: 390,
            supplies1: 593,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/15/2021"),
            tuition2: 6414,
            fee2: 180,
            textbooks2: 390,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/09/2022"),
            tuition3: 4990,
            fee3: 589,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/01/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("02/18/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2021",
            tuition1: 7221,
            fee1: 0,
            textbooks1: 719,
            supplies1: 719,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/15/2021"),
            tuition2: 7221,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/09/2022"),
            tuition3: 2406,
            fee3: 209,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/18/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "05172021": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/12/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7095,
            fee1: 0,
            textbooks1: 300,
            supplies1: 1491,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/26/2021"),
            tuition2: 7095,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/20/2022"),
            tuition3: 5397,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/15/2022"),
            tuition4: 5397,
            fee4: 120,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("08/12/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/13/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 6414,
            fee1: 0,
            textbooks1: 390,
            supplies1: 593,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/26/2021"),
            tuition2: 6414,
            fee2: 180,
            textbooks2: 390,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/20/2022"),
            tuition3: 4990,
            fee3: 589,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/13/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/13/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 6803,
            fee1: 0,
            textbooks1: 611,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/26/2021"),
            tuition2: 6803,
            fee2: 0,
            textbooks2: 610,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/20/2022"),
            tuition3: 4536.5,
            fee3: 596.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/13/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/13/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7380,
            fee1: 0,
            textbooks1: 265,
            supplies1: 568,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/26/2021"),
            tuition2: 7380,
            fee2: 0,
            textbooks2: 265,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/20/2022"),
            tuition3: 4920,
            fee3: 648,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/13/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("04/01/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7221,
            fee1: 0,
            textbooks1: 719,
            supplies1: 719,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/26/2021"),
            tuition2: 7221,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/20/2022"),
            tuition3: 2406,
            fee3: 209,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/01/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("12/16/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 6974,
            fee1: 0,
            textbooks1: 464,
            supplies1: 922,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/05/2021"),
            tuition2: 6974,
            fee2: 0,
            textbooks2: 463,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/09/2022"),
            tuition3: 7163,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/24/2022"),
            tuition4: 7163,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("08/14/2022"),
            tuition5: 4525,
            fee5: 0,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("10/16/2022"),
            tuition6: 4524,
            fee6: 778,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("12/16/2022")
        }
    },
    "07062021": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/23/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7095,
            fee1: 0,
            textbooks1: 300,
            supplies1: 1491,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/07/2021"),
            tuition2: 7095,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/03/2022"),
            tuition3: 5397,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("07/03/2022"),
            tuition4: 5397,
            fee4: 120,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("09/23/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/24/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 6414,
            fee1: 0,
            textbooks1: 390,
            supplies1: 593,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/07/2021"),
            tuition2: 6414,
            fee2: 180,
            textbooks2: 390,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/03/2022"),
            tuition3: 4990,
            fee3: 589,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/24/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/24/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 6803,
            fee1: 0,
            textbooks1: 611,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/07/2021"),
            tuition2: 6803,
            fee2: 0,
            textbooks2: 610,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/03/2022"),
            tuition3: 4536.5,
            fee3: 596.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/24/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/24/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7380,
            fee1: 0,
            textbooks1: 265,
            supplies1: 568,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/07/2021"),
            tuition2: 7380,
            fee2: 0,
            textbooks2: 265,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/03/2022"),
            tuition3: 4920,
            fee3: 648,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/24/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("05/13/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7221,
            fee1: 0,
            textbooks1: 719,
            supplies1: 719,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/07/2021"),
            tuition2: 7221,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/03/2022"),
            tuition3: 2406,
            fee3: 209,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/13/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("02/17/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 6974,
            fee1: 0,
            textbooks1: 464,
            supplies1: 922,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("10/17/2021"),
            tuition2: 6974,
            fee2: 0,
            textbooks2: 463,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/20/2022"),
            tuition3: 7163,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/05/2022"),
            tuition4: 7163,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("09/25/2022"),
            tuition5: 4525,
            fee5: 0,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("11/27/2022"),
            tuition6: 4524,
            fee6: 778,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("02/17/2023")
        }
    },
    "08162021": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/04/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7095,
            fee1: 0,
            textbooks1: 300,
            supplies1: 1491,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/09/2022"),
            tuition2: 7095,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 5397,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/14/2022"),
            tuition4: 5397,
            fee4: 120,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("11/04/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/12/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 6414,
            fee1: 0,
            textbooks1: 390,
            supplies1: 593,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/09/2022"),
            tuition2: 6414,
            fee2: 180,
            textbooks2: 390,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 4990,
            fee3: 589,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/12/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/12/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 6803,
            fee1: 0,
            textbooks1: 611,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/09/2022"),
            tuition2: 6803,
            fee2: 0,
            textbooks2: 610,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 4536.5,
            fee3: 596.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/12/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/12/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7380,
            fee1: 0,
            textbooks1: 265,
            supplies1: 568,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/09/2022"),
            tuition2: 7380,
            fee2: 0,
            textbooks2: 265,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 4920,
            fee3: 648,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/12/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("06/24/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 7221,
            fee1: 0,
            textbooks1: 719,
            supplies1: 719,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/09/2022"),
            tuition2: 7221,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 2406,
            fee3: 209,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/24/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/31/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "May 2021",
            tuition1: 6974,
            fee1: 0,
            textbooks1: 464,
            supplies1: 922,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/28/2021"),
            tuition2: 6974,
            fee2: 0,
            textbooks2: 463,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/03/2022"),
            tuition3: 7163,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("07/24/2022"),
            tuition4: 7163,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("11/06/2022"),
            tuition5: 4525,
            fee5: 0,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("01/29/2023"),
            tuition6: 4524,
            fee6: 778,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("03/31/2023")
        }
    },
    "09272021": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/16/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 7095,
            fee1: 0,
            textbooks1: 300,
            supplies1: 1491,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/20/2022"),
            tuition2: 7095,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 5397,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/25/2022"),
            tuition4: 5397,
            fee4: 120,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("12/16/2022"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/23/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 6414,
            fee1: 0,
            textbooks1: 390,
            supplies1: 593,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/20/2022"),
            tuition2: 6414,
            fee2: 180,
            textbooks2: 390,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 4990,
            fee3: 589,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/23/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/23/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 6803,
            fee1: 0,
            textbooks1: 611,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/20/2022"),
            tuition2: 6803,
            fee2: 0,
            textbooks2: 610,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 4536.5,
            fee3: 596.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/23/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/23/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 7380,
            fee1: 0,
            textbooks1: 265,
            supplies1: 568,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/20/2022"),
            tuition2: 7380,
            fee2: 0,
            textbooks2: 265,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 4920,
            fee3: 648,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/23/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("08/12/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 7221,
            fee1: 0,
            textbooks1: 719,
            supplies1: 719,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/20/2022"),
            tuition2: 7221,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 2406,
            fee3: 209,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/12/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/11/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 6974,
            fee1: 0,
            textbooks1: 464,
            supplies1: 922,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/30/2022"),
            tuition2: 6974,
            fee2: 0,
            textbooks2: 463,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 7163,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/05/2022"),
            tuition4: 7163,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/08/2023"),
            tuition5: 4525,
            fee5: 0,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/12/2023"),
            tuition6: 4524,
            fee6: 778,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("05/11/2023")
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/30/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 5738,
            fee1: 0,
            textbooks1: 388,
            supplies1: 593,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/30/2022"),
            tuition2: 5738,
            fee2: 0,
            textbooks2: 219,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 5738,
            fee3: 0,
            textbooks3: 129,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/05/2022"),
            tuition4: 5738,
            fee4: 180,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/08/2023"),
            tuition5: 4379,
            fee5: 589,
            textbooks5: 314,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/30/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 92.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/30/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 5753,
            fee1: 0,
            textbooks1: 398,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/30/2022"),
            tuition2: 5752,
            fee2: 0,
            textbooks2: 314,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 5753,
            fee3: 0,
            textbooks3: 574,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/05/2022"),
            tuition4: 5752,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/08/2023"),
            tuition5: 4277.5,
            fee5: 596.5,
            textbooks5: 314,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/30/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/30/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "September 2021",
            tuition1: 6120,
            fee1: 0,
            textbooks1: 214,
            supplies1: 568,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/30/2022"),
            tuition2: 6120,
            fee2: 0,
            textbooks2: 157,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/15/2022"),
            tuition3: 6120,
            fee3: 0,
            textbooks3: 223,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/05/2022"),
            tuition4: 6120,
            fee4: 100,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/08/2023"),
            tuition5: 4800,
            fee5: 548,
            textbooks5: 314,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/30/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "11082021": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/17/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 7095,
            fee1: 0,
            textbooks1: 300,
            supplies1: 1491,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/03/2022"),
            tuition2: 7095,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 5397,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/06/2022"),
            tuition4: 5397,
            fee4: 120,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/17/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/04/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 6414,
            fee1: 0,
            textbooks1: 390,
            supplies1: 593,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/03/2022"),
            tuition2: 6414,
            fee2: 180,
            textbooks2: 390,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 4990,
            fee3: 589,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/04/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/04/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 6803,
            fee1: 0,
            textbooks1: 611,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/03/2022"),
            tuition2: 6803,
            fee2: 0,
            textbooks2: 610,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 4536.5,
            fee3: 596.5,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/04/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/04/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 7380,
            fee1: 0,
            textbooks1: 265,
            supplies1: 568,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/03/2022"),
            tuition2: 7380,
            fee2: 0,
            textbooks2: 265,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 4920,
            fee3: 648,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/04/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("09/23/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 7221,
            fee1: 0,
            textbooks1: 719,
            supplies1: 719,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/03/2022"),
            tuition2: 7221,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 2406,
            fee3: 209,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/23/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("06/22/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 6974,
            fee1: 0,
            textbooks1: 464,
            supplies1: 922,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/13/2022"),
            tuition2: 6974,
            fee2: 0,
            textbooks2: 463,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 7163,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/16/2022"),
            tuition4: 7163,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/19/2023"),
            tuition5: 4525,
            fee5: 0,
            textbooks5: 0,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("04/23/2023"),
            tuition6: 4524,
            fee6: 778,
            textbooks6: 0,
            supplies6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("06/22/2023")
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/11/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 5738,
            fee1: 0,
            textbooks1: 388,
            supplies1: 593,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/13/2022"),
            tuition2: 5738,
            fee2: 0,
            textbooks2: 219,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 5738,
            fee3: 0,
            textbooks3: 129,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/16//2022"),
            tuition4: 5738,
            fee4: 180,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/19/2023"),
            tuition5: 4379,
            fee5: 589,
            textbooks5: 314,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("05/11/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 92.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/11/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 5753,
            fee1: 0,
            textbooks1: 398,
            supplies1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/13/2022"),
            tuition2: 5752,
            fee2: 0,
            textbooks2: 314,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 5753,
            fee3: 0,
            textbooks3: 574,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/16/2022"),
            tuition4: 5752,
            fee4: 0,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/19/2023"),
            tuition5: 4277.5,
            fee5: 596.5,
            textbooks5: 314,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("05/11/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/11/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "November 2021",
            tuition1: 6120,
            fee1: 0,
            textbooks1: 214,
            supplies1: 568,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/13/2022"),
            tuition2: 6120,
            fee2: 0,
            textbooks2: 157,
            supplies2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/03/2022"),
            tuition3: 6120,
            fee3: 0,
            textbooks3: 223,
            supplies3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/16/2022"),
            tuition4: 6120,
            fee4: 100,
            textbooks4: 0,
            supplies4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/19/2023"),
            tuition5: 4800,
            fee5: 548,
            textbooks5: 314,
            supplies5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("05/11/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "01102022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("03/31/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 246,
            supplies1: 1375,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/15/2022"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 116,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 5497.12,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("01/08/2023"),
            tuition4: 5497.12,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("03/31/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/16/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 7328,
            fee1: 0,
            textbooks1: 629,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/15/2022"),
            tuition2: 7328,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 5966.27,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("12/16/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/16/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 7406,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/15/2022"),
            tuition2: 7406,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 5470.16,
            fee3: 54,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("12/16/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/16/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 7449,
            fee1: 0,
            textbooks1: 367,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/15/2022"),
            tuition2: 7449,
            fee2: 0,
            textbooks2: 109,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 5499.09,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("12/16/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("11/04/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 7254,
            fee1: 0,
            textbooks1: 665,
            supplies1: 498,
            uniform1: 221,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("05/15/2022"),
            tuition2: 7253,
            fee2: 0,
            textbooks2: 54,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 2550.52,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/04/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("08/11/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 7313,
            fee1: 0,
            textbooks1: 336,
            supplies1: 809,
            uniform1: 113,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/24/2022"),
            tuition2: 7313,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 7312,
            fee3: 0,
            textbooks3: 268,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/27/2022"),
            tuition4: 7312,
            fee4: 0,
            textbooks4: 267,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("04/02/2023"),
            tuition5: 5076.99,
            fee5: 0,
            textbooks5: 0,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("06/04/2023"),
            tuition6: 5076.99,
            fee6: 0,
            textbooks6: 54,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("08/11/2023")
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("06/23/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 6726,
            fee1: 0,
            textbooks1: 509,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/24/2022"),
            tuition2: 6726,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 6726,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/27/2022"),
            tuition4: 6726,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("04/02/2023"),
            tuition5: 6448.05,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("06/23/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 92.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("06/23/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 6762,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/24/2022"),
            tuition2: 6762,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 6761,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/27/2022"),
            tuition4: 6761,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("04/02/2023"),
            tuition5: 6349.06,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("06/23/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("06/23/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "January 2022",
            tuition1: 6734,
            fee1: 0,
            textbooks1: 209,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/24/2022"),
            tuition2: 6734,
            fee2: 0,
            textbooks2: 209,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/14/2022"),
            tuition3: 6733,
            fee3: 0,
            textbooks3: 165,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/27/2022"),
            tuition4: 6733,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("04/02/2023"),
            tuition5: 6585.39,
            fee5: 0,
            textbooks5: 130,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("06/23/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "02212022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/12/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 246,
            supplies1: 1375,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2022"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 116,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 5497.12,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/05/2023"),
            tuition4: 5497.12,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("05/12/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/17/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 7328,
            fee1: 0,
            textbooks1: 629,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2022"),
            tuition2: 7328,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 5966.27,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/17/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/17/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 7406,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2022"),
            tuition2: 7406,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 5470.16,
            fee3: 54,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/17/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/17/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 7449,
            fee1: 0,
            textbooks1: 367,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2022"),
            tuition2: 7449,
            fee2: 0,
            textbooks2: 109,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 5499.09,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/17/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("12/16/2022"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 7254,
            fee1: 0,
            textbooks1: 665,
            supplies1: 498,
            uniform1: 221,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/04/2022"),
            tuition2: 7253,
            fee2: 0,
            textbooks2: 54,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 2550.52,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("12/16/2022"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("09/22/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 7313,
            fee1: 0,
            textbooks1: 336,
            supplies1: 809,
            uniform1: 113,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("06/05/2022"),
            tuition2: 7313,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 7312,
            fee3: 0,
            textbooks3: 268,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("01/29/2023"),
            tuition4: 7312,
            fee4: 0,
            textbooks4: 267,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("05/14/2023"),
            tuition5: 5076.99,
            fee5: 0,
            textbooks5: 0,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("07/23/2023"),
            tuition6: 5076.99,
            fee6: 0,
            textbooks6: 54,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("09/22/2023")
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("08/11/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 6726,
            fee1: 0,
            textbooks1: 509,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("06/05/2022"),
            tuition2: 6726,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 6726,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("01/29/2023"),
            tuition4: 6726,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("05/14/2023"),
            tuition5: 6448.05,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("08/11/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 92.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("08/11/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 6762,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("06/05/2022"),
            tuition2: 6762,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 6761,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("01/29/2023"),
            tuition4: 6761,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("05/14/2023"),
            tuition5: 6349.06,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("08/11/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("08/11/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "February 2022",
            tuition1: 6734,
            fee1: 0,
            textbooks1: 209,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("06/05/2022"),
            tuition2: 6734,
            fee2: 0,
            textbooks2: 209,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("09/25/2022"),
            tuition3: 6733,
            fee3: 0,
            textbooks3: 165,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("01/29/2023"),
            tuition4: 6733,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("05/14/2023"),
            tuition5: 6585.39,
            fee5: 0,
            textbooks5: 130,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("08/11/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "04042022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/23/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 246,
            supplies1: 1375,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/14/2022"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 116,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 5497.12,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/02/2023"),
            tuition4: 5497.12,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("06/23/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("03/31/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 7387,
            fee1: 0,
            textbooks1: 510,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/14/2022"),
            tuition2: 7387,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 5967.45,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/31/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("03/31/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 7406,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/14/2022"),
            tuition2: 7406,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 5473.16,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/31/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("03/31/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 7449,
            fee1: 0,
            textbooks1: 367,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/14/2022"),
            tuition2: 7449,
            fee2: 0,
            textbooks2: 109,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 5499.09,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/31/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("02/17/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 7254,
            fee1: 0,
            textbooks1: 665,
            supplies1: 498,
            uniform1: 221,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("08/14/2022"),
            tuition2: 7253,
            fee2: 0,
            textbooks2: 54,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 2550.52,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("02/17/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("11/03/2023"),
            financialAid_yes: "no",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 7313,
            fee1: 0,
            textbooks1: 336,
            supplies1: 809,
            uniform1: 113,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/24/2022"),
            tuition2: 7313,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 7312,
            fee3: 0,
            textbooks3: 268,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/12/2023"),
            tuition4: 7312,
            fee4: 0,
            textbooks4: 267,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("07/02/2023"),
            tuition5: 5076.99,
            fee5: 0,
            textbooks5: 0,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("09/03/2023"),
            tuition6: 5076.99,
            fee6: 0,
            textbooks6: 54,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("11/03/2023")
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("09/22/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 6726,
            fee1: 0,
            textbooks1: 509,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/24/2022"),
            tuition2: 6726,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 6726,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/12/2023"),
            tuition4: 6726,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("07/03/2023"),
            tuition5: 6448.16,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("09/22/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 92.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("09/22/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 6762,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/24/2022"),
            tuition2: 6762,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 6761,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/12/2023"),
            tuition4: 6761,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("07/03/2023"),
            tuition5: 6349.06,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("09/22/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("09/22/2023"),
            classAttendanceTime: "",
            volume: "IX",
            no: "1",
            date: "April 2022",
            tuition1: 6734,
            fee1: 0,
            textbooks1: 209,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("07/24/2022"),
            tuition2: 6734,
            fee2: 0,
            textbooks2: 209,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("11/06/2022"),
            tuition3: 6733,
            fee3: 0,
            textbooks3: 165,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/12/2023"),
            tuition4: 6733,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("07/02/2023"),
            tuition5: 6585.39,
            fee5: 0,
            textbooks5: 130,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("09/22/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "05162022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/11/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 246,
            supplies1: 1375,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/25/2022"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 116,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 5497.12,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/14/2023"),
            tuition4: 5497.12,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("08/11/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/12/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7387,
            fee1: 0,
            textbooks1: 510,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/25/2022"),
            tuition2: 7387,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 5967.45,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/12/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/12/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7406,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/25/2022"),
            tuition2: 7406,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 5473.16,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/12/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("05/12/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7449,
            fee1: 0,
            textbooks1: 367,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/25/2022"),
            tuition2: 7449,
            fee2: 0,
            textbooks2: 109,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 5499.09,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/12/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("03/31/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7254,
            fee1: 0,
            textbooks1: 665,
            supplies1: 498,
            uniform1: 221,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/25/2022"),
            tuition2: 7253,
            fee2: 0,
            textbooks2: 54,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 2550.52,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("03/31/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("12/15/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7313,
            fee1: 0,
            textbooks1: 336,
            supplies1: 809,
            uniform1: 113,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/04/2022"),
            tuition2: 7313,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 7312,
            fee3: 0,
            textbooks3: 268,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/23/2023"),
            tuition4: 7312,
            fee4: 0,
            textbooks4: 267,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("08/13/2023"),
            tuition5: 5076.99,
            fee5: 0,
            textbooks5: 0,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("10/15/2023"),
            tuition6: 5076.99,
            fee6: 0,
            textbooks6: 54,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("12/15/2023")
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("11/03/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6726,
            fee1: 0,
            textbooks1: 509,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/04/2022"),
            tuition2: 6726,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 6726,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/23/2023"),
            tuition4: 6726,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("08/13/2023"),
            tuition5: 6448.16,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("11/03/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 92.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("11/03/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6762,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/04/2022"),
            tuition2: 6762,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 6761,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/23/2023"),
            tuition4: 6761,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("08/13/2023"),
            tuition5: 6349.06,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("11/03/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("11/03/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6734,
            fee1: 0,
            textbooks1: 209,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("09/04/2022"),
            tuition2: 6734,
            fee2: 0,
            textbooks2: 209,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("01/08/2023"),
            tuition3: 6733,
            fee3: 0,
            textbooks3: 165,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("04/23/2023"),
            tuition4: 6733,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("08/13/2023"),
            tuition5: 6585.39,
            fee5: 0,
            textbooks5: 130,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("11/03/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "07052022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/22/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 246,
            supplies1: 1375,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/06/2022"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 116,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 5497.12,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("07/02/2023"),
            tuition4: 5497.12,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("09/22/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/23/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7387,
            fee1: 0,
            textbooks1: 510,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/06/2022"),
            tuition2: 7387,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 5967.45,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/23/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/23/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7406,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/06/2022"),
            tuition2: 7406,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 5473.16,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/23/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("06/23/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7449,
            fee1: 0,
            textbooks1: 367,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/06/2022"),
            tuition2: 7449,
            fee2: 0,
            textbooks2: 109,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 5499.09,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/23/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("05/12/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7254,
            fee1: 0,
            textbooks1: 665,
            supplies1: 498,
            uniform1: 221,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/06/2022"),
            tuition2: 7253,
            fee2: 0,
            textbooks2: 54,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 2550.52,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("05/12/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("02/16/2024"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7313,
            fee1: 0,
            textbooks1: 336,
            supplies1: 809,
            uniform1: 113,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("10/16/2022"),
            tuition2: 7313,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 7312,
            fee3: 0,
            textbooks3: 268,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/04/2023"),
            tuition4: 7312,
            fee4: 0,
            textbooks4: 267,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("09/24/2023"),
            tuition5: 5076.99,
            fee5: 0,
            textbooks5: 0,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("11/26/2023"),
            tuition6: 5076.99,
            fee6: 0,
            textbooks6: 54,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("02/16/2024")
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("12/15/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6726,
            fee1: 0,
            textbooks1: 509,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("10/16/2022"),
            tuition2: 6726,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 6726,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/04/2023"),
            tuition4: 6726,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("09/24/2023"),
            tuition5: 6448.16,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("12/15/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 92.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("12/15/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6762,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("10/16/2022"),
            tuition2: 6762,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 6761,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/04/2023"),
            tuition4: 6761,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("09/24/2023"),
            tuition5: 6349.06,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("12/15/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("12/15/2023"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6734,
            fee1: 0,
            textbooks1: 209,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("10/16/2022"),
            tuition2: 6734,
            fee2: 0,
            textbooks2: 209,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("02/19/2023"),
            tuition3: 6733,
            fee3: 0,
            textbooks3: 165,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/04/2023"),
            tuition4: 6733,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("09/24/2023"),
            tuition5: 6585.39,
            fee5: 0,
            textbooks5: 130,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("12/15/2023"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "08152022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/03/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 246,
            supplies1: 1375,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/08/2023"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 116,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 5497.12,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/13/2023"),
            tuition4: 5497.12,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("11/03/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/11/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7387,
            fee1: 0,
            textbooks1: 510,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/08/2023"),
            tuition2: 7387,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 5967.45,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/11/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/11/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7406,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/08/2023"),
            tuition2: 7406,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 5473.16,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/11/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("08/11/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7449,
            fee1: 0,
            textbooks1: 367,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/08/2023"),
            tuition2: 7449,
            fee2: 0,
            textbooks2: 109,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 5499.09,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/11/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("06/23/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7254,
            fee1: 0,
            textbooks1: 665,
            supplies1: 498,
            uniform1: 221,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/08/2023"),
            tuition2: 7253,
            fee2: 0,
            textbooks2: 54,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 2550.52,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("06/23/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/29/2024"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7313,
            fee1: 0,
            textbooks1: 336,
            supplies1: 809,
            uniform1: 113,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/27/2022"),
            tuition2: 7313,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 7312,
            fee3: 0,
            textbooks3: 268,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("07/23/2023"),
            tuition4: 7312,
            fee4: 0,
            textbooks4: 267,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("11/05/2023"),
            tuition5: 5076.99,
            fee5: 0,
            textbooks5: 0,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("01/28/2024"),
            tuition6: 5076.99,
            fee6: 0,
            textbooks6: 54,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("03/29/2024")
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("02/16/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6726,
            fee1: 0,
            textbooks1: 509,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/27/2022"),
            tuition2: 6726,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 6726,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("07/23/2023"),
            tuition4: 6726,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("11/05/2023"),
            tuition5: 6448.16,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("02/16/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 92.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("02/16/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6762,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/27/2022"),
            tuition2: 6762,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 6761,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("07/23/2023"),
            tuition4: 6761,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("11/05/2023"),
            tuition5: 6349.06,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("02/16/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("02/16/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6734,
            fee1: 0,
            textbooks1: 209,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("11/27/2022"),
            tuition2: 6734,
            fee2: 0,
            textbooks2: 209,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("04/02/2023"),
            tuition3: 6733,
            fee3: 0,
            textbooks3: 165,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("07/23/2023"),
            tuition4: 6733,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("11/05/2023"),
            tuition5: 6585.39,
            fee5: 0,
            textbooks5: 130,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("02/16/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "09262022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("12/15/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 246,
            supplies1: 1375,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/19/2023"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 116,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 5497.12,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/24/2023"),
            tuition4: 5497.12,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("12/15/2023"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/22/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7387,
            fee1: 0,
            textbooks1: 510,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/19/2023"),
            tuition2: 7387,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 5967.45,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/22/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/22/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7406,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/19/2023"),
            tuition2: 7406,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 5473.16,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/22/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("09/22/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7449,
            fee1: 0,
            textbooks1: 367,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/19/2023"),
            tuition2: 7449,
            fee2: 0,
            textbooks2: 109,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 5499.09,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/22/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("08/11/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7254,
            fee1: 0,
            textbooks1: 665,
            supplies1: 498,
            uniform1: 221,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("02/19/2023"),
            tuition2: 7253,
            fee2: 0,
            textbooks2: 54,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 2550.52,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("08/11/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/10/2024"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7313,
            fee1: 0,
            textbooks1: 336,
            supplies1: 809,
            uniform1: 113,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/29/2023"),
            tuition2: 7313,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 7312,
            fee3: 0,
            textbooks3: 268,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/03/2023"),
            tuition4: 7312,
            fee4: 0,
            textbooks4: 267,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/07/2024"),
            tuition5: 5076.99,
            fee5: 0,
            textbooks5: 0,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/10/2024"),
            tuition6: 5076.99,
            fee6: 0,
            textbooks6: 54,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("05/10/2024")
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/29/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6726,
            fee1: 0,
            textbooks1: 509,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/29/2023"),
            tuition2: 6726,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 6726,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/03/2023"),
            tuition4: 6726,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/07/2024"),
            tuition5: 6448.16,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/29/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 92.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/29/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6762,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/29/2023"),
            tuition2: 6762,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 6761,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/03/2023"),
            tuition4: 6761,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/07/2024"),
            tuition5: 6349.06,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/29/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("03/29/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6734,
            fee1: 0,
            textbooks1: 209,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("01/29/2023"),
            tuition2: 6734,
            fee2: 0,
            textbooks2: 209,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("05/14/2023"),
            tuition3: 6733,
            fee3: 0,
            textbooks3: 165,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/03/2023"),
            tuition4: 6733,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("01/07/2024"),
            tuition5: 6585.39,
            fee5: 0,
            textbooks5: 130,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("03/29/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    },
    "11072022": {
        ATM: {
            programType: "Quarter_Credit",
            programHour: 72,
            programLength: 15,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("02/16/2024"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7055,
            fee1: 0,
            textbooks1: 246,
            supplies1: 1375,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/02/2023"),
            tuition2: 7055,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 116,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/13/2023"),
            tuition3: 5497.12,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/05/2023"),
            tuition4: 5497.12,
            fee4: 0,
            textbooks4: 54,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/16/2024"),
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MA: {
            programType: "Quarter_Credit",
            programHour: 59,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/03/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7387,
            fee1: 0,
            textbooks1: 510,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/02/2023"),
            tuition2: 7387,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/13/2023"),
            tuition3: 5967.45,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/03/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/03/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7406,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/02/2023"),
            tuition2: 7406,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/13/2023"),
            tuition3: 5473.16,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/03/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CST: {
            programType: "Quarter_Credit",
            programHour: 61.5,
            programLength: 12,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            programGraduationDate: new Date("11/03/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7449,
            fee1: 0,
            textbooks1: 367,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/02/2023"),
            tuition2: 7449,
            fee2: 0,
            textbooks2: 109,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/13/2023"),
            tuition3: 5499.09,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("11/03/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        ET: {
            programType: "Quarter_Credit",
            programHour: 54,
            programLength: 10.5,
            programCheckbox_associate: "no",
            programCheckbox_certificate: "yes",
            classAttendanceTime: "",
            programGraduationDate: new Date("09/22/2023"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7254,
            fee1: 0,
            textbooks1: 665,
            supplies1: 498,
            uniform1: 221,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("04/02/2023"),
            tuition2: 7253,
            fee2: 0,
            textbooks2: 54,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("08/13/2023"),
            tuition3: 2550.52,
            fee3: 0,
            textbooks3: 0,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("09/22/2023"),
            tuition4: "",
            fee4: "",
            textbooks4: "",
            supplies4: "",
            uniform4: "",
            other4: "",
            paymentReceive4: "",
            cancellationFee4: "",
            endDate4: "",
            tuition5: "",
            fee5: "",
            textbooks5: "",
            supplies5: "",
            uniform5: "",
            other5: "",
            paymentReceive5: "",
            cancellationFee5: "",
            endDate5: "",
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        HVAC: {
            programType: "Quarter_Credit",
            programHour: 99,
            programLength: 19.5,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("06/21/2024"),
            financialAid_yes: "no",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 7313,
            fee1: 0,
            textbooks1: 336,
            supplies1: 809,
            uniform1: 113,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/12/2023"),
            tuition2: 7313,
            fee2: 0,
            textbooks2: 0,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 7312,
            fee3: 0,
            textbooks3: 268,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/15/2023"),
            tuition4: 7312,
            fee4: 0,
            textbooks4: 267,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/18/2024"),
            tuition5: 5076.99,
            fee5: 0,
            textbooks5: 0,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("04/21/2024"),
            tuition6: 5076.99,
            fee6: 0,
            textbooks6: 54,
            supplies6: 0,
            uniform6: 0,
            other6: 0,
            paymentReceive6: 0,
            cancellationFee6: 0,
            endDate6: new Date("06/21/2024")
        },
        MA_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 90.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/10/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6726,
            fee1: 0,
            textbooks1: 509,
            supplies1: 561,
            uniform1: 32,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/12/2023"),
            tuition2: 6726,
            fee2: 0,
            textbooks2: 97,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 6726,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/15/2023"),
            tuition4: 6726,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/18/2024"),
            tuition5: 6448.16,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("05/10/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        MBC_DEGREE: {
            programType: "Quarter_Credit",
            programHour: 92.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/10/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6762,
            fee1: 0,
            textbooks1: 578,
            supplies1: 0,
            uniform1: 0,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/12/2023"),
            tuition2: 6762,
            fee2: 0,
            textbooks2: 578,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 6761,
            fee3: 0,
            textbooks3: 54,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/15/2023"),
            tuition4: 6761,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/18/2024"),
            tuition5: 6349.06,
            fee5: 0,
            textbooks5: 195,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("05/10/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        },
        CNST: {
            programType: "Quarter_Credit",
            programHour: 91.5,
            programLength: 18,
            programCheckbox_associate: "yes",
            programCheckbox_certificate: "no",
            programGraduationDate: new Date("05/10/2024"),
            classAttendanceTime: "",
            volume: "X",
            no: "1",
            date: "April 2022",
            tuition1: 6734,
            fee1: 0,
            textbooks1: 209,
            supplies1: 534,
            uniform1: 34,
            other1: 0,
            paymentReceive1: 0,
            cancellationFee1: 0,
            endDate1: new Date("03/12/2023"),
            tuition2: 6734,
            fee2: 0,
            textbooks2: 209,
            supplies2: 0,
            uniform2: 0,
            other2: 0,
            paymentReceive2: 0,
            cancellationFee2: 0,
            endDate2: new Date("07/02/2023"),
            tuition3: 6733,
            fee3: 0,
            textbooks3: 165,
            supplies3: 0,
            uniform3: 0,
            other3: 0,
            paymentReceive3: 0,
            cancellationFee3: 0,
            endDate3: new Date("10/15/2023"),
            tuition4: 6733,
            fee4: 0,
            textbooks4: 195,
            supplies4: 0,
            uniform4: 0,
            other4: 0,
            paymentReceive4: 0,
            cancellationFee4: 0,
            endDate4: new Date("02/18/2024"),
            tuition5: 6585.39,
            fee5: 0,
            textbooks5: 130,
            supplies5: 0,
            uniform5: 0,
            other5: 0,
            paymentReceive5: 0,
            cancellationFee5: 0,
            endDate5: new Date("05/10/2024"),
            tuition6: "",
            fee6: "",
            textbooks6: "",
            supplies6: "",
            uniform6: "",
            other6: "",
            paymentReceive6: "",
            cancellationFee6: "",
            endDate6: ""
        }
    }
};
//# sourceMappingURL=data:application/json;base64,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